import React from 'react';
import { Link } from 'react-router-dom';
import db from '../data/db.json';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-logo">
            <span className="logo-icon">{db.site.logo}</span>
            {db.site.name}
          </h3>
          <p className="footer-tagline">{db.site.tagline}</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p>{db.site.contact.address}</p>
          <p>Phone: {db.site.contact.phone}</p>
          <p>Email: {db.site.contact.email}</p>
          <p className="footer-hours">{db.site.contact.hours}</p>
        </div>

        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-links">
            <a href={db.site.social.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href={db.site.social.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href={db.site.social.twitter} target="_blank" rel="noopener noreferrer">Twitter</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} {db.site.name}. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

